import React, { useRef } from "react"
import { Outlet, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import ReactLenis, { Lenis, useLenis } from "lenis/react";
import ScrollArrow from "../../../components/scroll-to-top-arrow";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const lnet = <svg xmlns="http://www.w3.org/2000/svg" style={{ height: "19px", width: "auto" }} width="64" height="16" viewBox="0 0 64 16" fill="none">
    <g clip-path="url(#clip0_5219_8821)">
        <path d="M22.7246 2.67346C22.5262 2.29552 22.2495 1.96421 21.9109 1.68934C20.0119 0.799707 17.4875 2.17527 16.0889 3.76066C16.7762 3.02809 17.6732 2.43786 18.6828 2.29061C18.8407 2.2673 19.0037 2.25625 19.1667 2.25625C19.4509 2.25625 19.7403 2.29061 20.0132 2.36301C20.5944 2.5164 21.1061 2.83544 21.3727 3.341C22.2647 5.03928 20.1395 6.14979 19.2286 7.5143C19.0504 7.78181 18.9178 8.05913 18.8647 8.3524C18.7737 8.8506 18.8622 9.35493 18.9822 9.85435C19.1224 10.4421 19.3044 11.0225 19.2867 11.5821V11.6066C19.2778 12.8644 18.5855 15.1284 16.7421 15.1284C17.8918 15.1284 19.0252 14.6878 19.7744 13.9467C21.2034 12.5355 20.8117 10.928 20.5413 9.85435C20.5388 9.84576 20.5375 9.83717 20.535 9.82981C20.4162 9.35738 20.3025 8.91072 20.3581 8.60886C20.4049 8.34872 20.8193 7.90452 21.197 7.51553C21.2387 7.47258 21.2804 7.43086 21.3221 7.38791C21.8123 6.88604 22.3695 6.31544 22.7258 5.6295C23.2299 4.65643 23.2299 3.63427 22.7258 2.67346H22.7246Z" fill="white" />
        <path d="M3.38799 2.36422C3.6609 2.29183 3.95023 2.25747 4.23451 2.25747C4.3975 2.25747 4.56048 2.26851 4.71842 2.29183C5.72792 2.43785 6.62498 3.0293 7.3123 3.76187C5.91491 2.17525 3.38925 0.799694 1.49154 1.68933C1.15419 1.9642 0.87623 2.29551 0.677867 2.67345C0.172482 3.63425 0.172482 4.65642 0.677867 5.62949C1.03416 6.31666 1.59135 6.88602 2.08157 7.3879C2.12327 7.42962 2.1637 7.47257 2.20665 7.51552C2.58443 7.9045 2.99884 8.34871 3.04559 8.60885C3.09992 8.91071 2.98747 9.35737 2.86871 9.8298C2.86618 9.83839 2.86492 9.84697 2.86239 9.85434C2.59201 10.9268 2.20034 12.5343 3.62931 13.9467C4.37854 14.6878 5.51187 15.1283 6.66162 15.1283C4.81823 15.1283 4.12585 12.8644 4.11701 11.6066V11.5821C4.09806 11.0237 4.27999 10.4433 4.4215 9.85434C4.54027 9.35491 4.62871 8.85058 4.539 8.35239C4.48594 8.05912 4.35328 7.78179 4.17513 7.51429C3.26417 6.14977 1.13903 5.03926 2.03103 3.34098C2.29762 2.83542 2.80933 2.51638 3.39052 2.363L3.38799 2.36422Z" fill="white" />
        <path d="M16.0892 3.76011C17.4878 2.17471 20.0135 0.799155 21.9112 1.68879C21.2062 1.11329 20.2371 0.783203 19.167 0.783203C18.9282 0.783203 18.6906 0.800382 18.4594 0.833514C17.1909 1.01758 15.983 1.68634 14.9685 2.76862C14.1599 3.62881 13.5837 4.62888 13.0733 5.50992L11.7012 7.88433L12.1396 8.64144L12.5565 9.36174C12.5565 9.36174 13.8023 7.25974 14.3974 6.23022C14.8965 5.36513 15.4031 4.4939 16.0904 3.76011H16.0892Z" fill="white" />
        <path d="M11.2626 10.0836L10.847 9.36328C10.847 9.36328 8.99346 12.7746 7.73758 13.4139C7.41161 13.5808 7.03762 13.6556 6.65985 13.6556C6.22774 13.6556 5.79058 13.5575 5.40902 13.3844C5.1399 13.263 4.89858 13.1034 4.7078 12.9157C4.28707 12.5009 4.13419 12.0616 4.11523 11.6076C4.12408 12.8654 4.81646 15.1293 6.65985 15.1293C7.29916 15.1293 7.91573 14.987 8.44259 14.7195C9.92716 13.9624 10.3289 13.2556 11.5216 11.1622C11.5785 11.0628 11.6391 10.9573 11.6998 10.8493V10.8468C11.5659 10.6125 11.4218 10.3597 11.2626 10.0848V10.0836Z" fill="white" />
        <path d="M18.6942 12.9141C18.5034 13.1019 18.2634 13.2614 17.993 13.3829C17.6114 13.5559 17.1743 13.6541 16.7422 13.6541C16.3644 13.6541 15.9904 13.5792 15.6644 13.4123C14.4098 12.773 12.5551 9.36174 12.5551 9.36174L12.1381 8.64144L11.6997 7.88433L11.6959 7.89047C11.6959 7.88801 11.6984 7.88678 11.6984 7.88433L10.3263 5.50993C9.81587 4.62888 9.23847 3.62881 8.43112 2.76862C7.41909 1.68634 6.21122 1.01758 4.9427 0.833514C4.71149 0.800382 4.47396 0.783203 4.23516 0.783203C3.16627 0.783203 2.1972 1.11329 1.49219 1.68879C3.38991 0.799155 5.91557 2.17471 7.31422 3.76011C8.00154 4.4939 8.50819 5.36513 9.00726 6.23022C9.60235 7.25975 10.8481 9.36174 10.8481 9.36174C10.8506 9.35806 10.8532 9.35315 10.8557 9.34947L10.8481 9.36174L11.2638 10.082C11.423 10.3569 11.567 10.6097 11.701 10.8441C11.701 10.8441 11.701 10.8453 11.7022 10.8465C11.7641 10.9557 11.8248 11.06 11.8804 11.1606C13.0731 13.254 13.4749 13.9596 14.9594 14.718C15.4863 14.9867 16.1029 15.1278 16.7422 15.1278C18.5856 15.1278 19.2779 12.8638 19.2868 11.6061C19.2678 12.0601 19.1149 12.5006 18.6942 12.9141Z" fill="white" />
        <path d="M25.8447 2.07315C25.8447 1.64613 26.0646 1.43262 26.5043 1.43262H27.1448C27.5845 1.43262 27.8044 1.64613 27.8044 2.07315V13.4777H33.4861C33.9069 13.4777 34.1457 13.6912 34.1457 14.1182V14.5072C34.1457 14.9342 33.9056 15.1477 33.4861 15.1477H26.5043C26.0646 15.1477 25.8447 14.9342 25.8447 14.5072V2.07315Z" fill="white" />
        <path d="M35.6475 5.95889C35.6475 5.53187 35.8875 5.31836 36.307 5.31836H36.8667C37.3064 5.31836 37.5262 5.53187 37.5262 5.95889V6.83258C37.5262 7.1234 37.4656 7.39581 37.4656 7.39581H37.506C37.9065 6.54053 39.1258 5.08398 41.3469 5.08398C43.7273 5.08398 44.8076 6.34665 44.8076 8.85358V14.5068C44.8076 14.9338 44.5877 15.1473 44.148 15.1473H43.5277C43.1069 15.1473 42.8681 14.9338 42.8681 14.5068V9.28061C42.8681 7.90137 42.5877 6.81294 40.9679 6.81294C39.007 6.81294 37.5869 8.4057 37.5869 10.4463V14.5068C37.5869 14.9338 37.367 15.1473 36.9273 15.1473H36.307C35.8863 15.1473 35.6475 14.9338 35.6475 14.5068V5.95889Z" fill="white" />
        <path d="M51.8897 5.08423C54.6908 5.08423 56.2511 7.02671 56.2511 9.76678C56.2511 10.1165 55.9706 10.427 55.5714 10.427H48.8106C48.9306 12.5645 50.5112 13.7487 52.3117 13.7487C53.4121 13.7487 54.2726 13.302 54.7325 12.9719C55.1128 12.778 55.4122 12.8161 55.6333 13.1854L55.814 13.4763C56.0136 13.8063 55.9542 14.1364 55.6144 14.3315C55.0142 14.7389 53.8139 15.3807 52.1929 15.3807C49.0128 15.3807 46.832 13.1462 46.832 10.2318C46.832 7.10401 49.0128 5.08301 51.8935 5.08301L51.8897 5.08423ZM54.3105 9.18392C54.2498 7.45496 53.1898 6.56164 51.8505 6.56164C50.3697 6.56164 49.1694 7.53349 48.8902 9.18392H54.3117H54.3105Z" fill="white" />
        <path d="M58.7917 6.94977H58.0917C57.6723 6.94977 57.4512 6.71662 57.4512 6.30923V6.05645C57.4512 5.64906 57.671 5.41591 58.1107 5.41591H58.8309V3.2587C58.8309 2.83168 59.0709 2.61816 59.4904 2.61816H60.0703C60.51 2.61816 60.7299 2.83168 60.7299 3.2587V5.41469H62.4899C62.9295 5.41469 63.1494 5.64783 63.1494 6.05522V6.308C63.1494 6.71662 62.9295 6.94854 62.5088 6.94854H60.7286V11.3194C60.7286 13.1846 61.9087 13.4754 62.6491 13.5343C63.1696 13.5736 63.349 13.7282 63.349 14.1748V14.5834C63.349 15.0301 63.0887 15.224 62.5492 15.224C60.5492 15.224 58.7879 14.0975 58.7879 11.6102V6.94977H58.7917Z" fill="white" />
    </g>
    <defs>
        <clipPath id="clip0_5219_8821">
            <rect width="63.0543" height="14.5986" fill="white" transform="translate(0.299805 0.783203)" />
        </clipPath>
    </defs>
</svg>

const gada = <svg xmlns="http://www.w3.org/2000/svg" style={{ height: "26px", width: "auto" }} width="41" height="17" viewBox="0 0 41 17" fill="none">
    <mask id="mask0_5219_8832" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="17">
        <path d="M40.4631 0.274414H0.694336V16.4765H40.4631V0.274414Z" fill="white" />
    </mask>
    <g mask="url(#mask0_5219_8832)">
        <path opacity="0.25" d="M6.80782 16.4758C10.1767 16.4758 12.9077 15.9644 12.9077 15.3336C12.9077 14.7028 10.1767 14.1914 6.80782 14.1914C3.43899 14.1914 0.708008 14.7028 0.708008 15.3336C0.708008 15.9644 3.43899 16.4758 6.80782 16.4758Z" fill="url(#paint0_radial_5219_8832)" />
        <path d="M13.762 8.00596C13.76 8.04926 13.7013 8.05707 13.6885 8.01587C13.4486 7.25546 12.9632 6.6438 12.5201 6.21126C12.033 5.73575 11.3034 5.63898 10.7141 5.97048L8.95219 6.9618C8.64283 7.13581 8.26282 7.10217 7.98675 6.87672L6.60333 5.74596C6.60333 5.74596 6.16553 5.32515 5.71551 5.90288C5.53046 6.14031 5.57774 6.48929 5.81415 6.67233C7.11468 7.67956 8.46245 9.04657 9.09463 9.71022C9.21781 9.83979 9.11274 10.0565 8.9382 10.0327L7.86209 9.88608C7.83351 9.88216 7.80489 9.88034 7.77632 9.88034C7.57025 9.88034 7.37382 9.98074 7.2498 10.1545C7.01516 10.4833 7.17537 10.988 7.5676 11.0463C8.87398 11.2401 10.5551 12.0544 11.8857 12.327C12.0091 12.3522 12.029 12.5263 11.9137 12.5786C11.742 12.6564 11.5646 12.7103 11.3851 12.734C10.1386 12.9101 8.8918 13.0066 7.64498 13.0234C7.14036 13.0304 6.6515 13.2074 6.25106 13.523L3.97456 15.3162C3.79507 15.4578 3.53911 15.3027 3.57268 15.0728L3.8263 13.3303C3.86541 13.0607 3.68124 12.8107 3.41799 12.7764C3.3138 12.7625 3.2099 12.7484 3.1057 12.734C2.09266 12.5753 1.10005 11.5005 0.961423 10.4622C0.605356 7.9191 0.605356 5.38195 0.961131 2.83853C1.09976 1.80005 2.09237 0.725499 3.10541 0.566796C5.86491 0.176953 8.6256 0.176953 11.3848 0.566796C12.4128 0.703557 13.3718 1.81778 13.5291 2.83853C13.7702 4.56262 13.8478 6.28367 13.762 8.00596Z" fill="white" />
    </g>
    <path d="M19.6635 5.16302H21.8096V5.51377C21.8096 7.27181 21.66 8.45903 21.3611 9.07465C21.066 9.70634 20.5132 10.022 19.7033 10.022C18.8933 10.022 18.2705 9.67123 17.9148 8.96937C17.5629 8.26784 17.3867 7.0884 17.3867 5.43184C17.3867 3.53726 17.5799 2.27629 17.966 1.64853C18.3292 1.05979 18.8877 0.765625 19.6408 0.765625C20.2162 0.765625 20.6644 0.908028 20.9864 1.19245C21.3118 1.48077 21.5657 1.95442 21.7472 2.61338L20.6458 3.08702C20.5966 2.84942 20.5416 2.64967 20.481 2.48775C20.4204 2.32623 20.3542 2.20021 20.2821 2.11048C20.1382 1.9275 19.9226 1.83581 19.6347 1.83581C19.2411 1.83581 18.9721 2.08551 18.8285 2.58412C18.6846 3.10653 18.6126 4.04407 18.6126 5.39672C18.6126 6.74935 18.6865 7.69083 18.8338 8.17422C18.9816 8.65761 19.2597 8.89914 19.6684 8.89914C20.0431 8.89914 20.306 8.72784 20.4576 8.38453C20.6125 8.01815 20.6901 7.42941 20.6901 6.61871V6.19185H19.6624V5.16263L19.6635 5.16302Z" fill="white" />
    <path d="M24.3475 0.882812H25.2673L27.1468 9.91091H25.9773L25.6481 8.15095H23.9107L23.5758 9.91091H22.4404L24.3483 0.882812H24.3475ZM25.4772 7.20954L25.2162 5.77103C25.0419 4.79252 24.9003 3.74808 24.7904 2.63694C24.7374 3.17885 24.6692 3.72741 24.5858 4.28299C24.5025 4.83856 24.404 5.42808 24.2907 6.05151L24.0748 7.2091L25.4772 7.20954Z" fill="white" />
    <path d="M28.2344 10.0213V0.878906H30.0835C30.5305 0.878906 30.9146 0.931572 31.2256 1.03574C31.5272 1.14069 32.058 1.32758 32.2906 1.5921C32.6293 1.97679 32.8732 2.48203 33.0157 3.09302C33.1544 3.66849 33.2248 4.50029 33.2248 5.56424C33.2248 6.54156 33.1468 7.35271 32.9929 7.97496C32.8372 8.59257 32.574 9.07245 32.2099 9.40219C31.7575 9.81847 30.7271 10.0213 29.597 10.0213H28.2344ZM29.9922 8.62265C30.5309 8.59104 30.8839 8.40807 31.0692 8.06552C31.2969 7.65702 31.4117 6.83108 31.4117 5.6095C31.4117 4.28844 31.3003 3.37431 31.0802 2.89248C30.8813 2.45707 30.5252 2.24132 29.9922 2.23351V8.62265Z" fill="white" />
    <path d="M37.2728 10.0213L36.9523 8.30897H35.2881L34.9623 10.0213H33.498L35.4301 0.878906H36.8667L38.77 10.0213H37.2728ZM36.1484 4.23616L35.5158 7.03432H36.7208L36.1484 4.23616Z" fill="white" />
    <path d="M18.9511 12.3428V14.4695H18.6125V12.6213H17.8828V12.3428H18.9511ZM17.8828 13.1563H18.2181V14.4695H17.8828V13.1563Z" fill="white" />
    <path d="M19.7346 12.6213H19.1729V12.3428H20.2965V12.6213H20.0847V14.4695H19.7346V12.6213Z" fill="white" />
    <path d="M20.9048 12.3428V13.4629H20.5498V12.3428H20.9048Z" fill="white" />
    <path d="M21.8334 14.1944H22.1153V13.0037C22.1153 12.7657 22.0486 12.5979 21.8334 12.5979H21.7504L21.5308 14.4695H21.2246L21.4656 12.6213H21.2394V12.3428H21.8304C22.2881 12.3428 22.4346 12.5574 22.4313 13.2503V14.4695H21.8334V14.1944Z" fill="white" />
    <path d="M23.2022 14.4708H22.8749L23.259 12.6226H22.6631V11.9082H22.9741V12.3444H23.6564L23.2022 14.4708Z" fill="white" />
    <path d="M25.9778 13.262V14.4695H25.652V13.1598C25.652 12.8445 25.6649 12.5929 25.377 12.5929H25.2091V14.4695H24.6113V14.1909H24.9159V12.6213H24.7826V12.3428H25.3686C25.9354 12.3428 25.9778 12.7216 25.9778 13.262Z" fill="white" />
    <path d="M26.564 12.3428V13.4629H26.209V12.3428H26.564Z" fill="white" />
    <path d="M27.1645 12.3428V13.4629H26.8096V12.3428H27.1645Z" fill="white" />
    <path d="M28.3968 12.3428V14.4695H28.0498V12.3428H28.3968Z" fill="white" />
    <path d="M27.7904 12.3428V14.4695H27.4434V12.3428H27.7904Z" fill="white" />
    <path d="M29.8445 13.262V14.4695H29.5107V13.1679C29.5107 12.8511 29.5107 12.6213 29.2194 12.6213H29.0076V14.4695H28.6738V12.3428H29.2406C29.8009 12.3428 29.8445 12.7216 29.8445 13.262Z" fill="white" />
    <path d="M32.0724 14.4695H30.9961V12.3428H31.5451C31.9084 12.3428 32.0728 12.4333 32.0728 12.9666L32.0724 14.4695ZM31.7598 12.9752C31.7598 12.6834 31.6769 12.6178 31.5091 12.6178H31.3087V14.1944H31.7598V12.9752Z" fill="white" />
    <path d="M32.7124 12.3428V13.4629H32.3574V12.3428H32.7124Z" fill="white" />
    <path d="M34.119 14.4695H33.0215V14.1909H33.5571V12.6213H33.0313V12.3428H33.8992V14.1909H34.119V14.4695Z" fill="white" />
    <path d="M34.3403 14.1944H35.039L34.249 12.3428H34.5828L35.0143 13.3576C35.0942 13.3326 35.1802 13.2753 35.1802 13.0525V12.3432H35.4928V12.9467C35.4928 13.2554 35.3803 13.5288 35.0969 13.5656L35.5041 14.4695H34.34L34.3403 14.1944Z" fill="white" />
    <path d="M36.9317 12.3428V13.406C36.9317 13.9927 36.912 14.1909 36.243 14.3989C36.0588 14.4574 35.7755 14.5316 35.7755 14.5316L35.7168 14.285L36.0149 14.1944L35.8308 12.3428H36.1547L36.3093 14.1004C36.6006 14.0267 36.6203 13.9026 36.6203 13.5371V12.3428H36.9317Z" fill="white" />
    <path d="M37.7553 14.1944H38.0372V13.0037C38.0372 12.7657 37.9705 12.5979 37.7553 12.5979H37.6723L37.4526 14.4695H37.1465L37.3874 12.6213H37.1613V12.3428H37.7522C38.2099 12.3428 38.3565 12.5574 38.3531 13.2503V14.4695H37.7553V14.1944Z" fill="white" />
    <defs>
        <radialGradient id="paint0_radial_5219_8832" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.82093 15.3335) scale(6.12203 1.14218)">
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
    </defs>
</svg>;


const ProgarmModalButton = ({ style, n }) => (
    <button
        aria-label="סגור"
        className="modal-button"
        type="button"
        onClick={() => n('/gefen', { state: { dontReload: true } })}
        style={style}
    >
        <FontAwesomeIcon icon={faXmark} color="white" />
    </button>
);




export default function GefenProgramsBackdrop() {
    const lenisRef = useRef(null);
    const n = useNavigate();
    useLenis();

    // useEffect(() => {
    //     function update(time) {
    //         lenisRef?.current?.lenis?.raf(time * 800)
    //     }

    //     gsap.ticker.add(update)

    //     return () => gsap.ticker.remove(update)
    // }, [lenisRef])

    useGSAP(context => {

        setTimeout(() => {
            // Ensure ScrollTrigger recalculates positions
            ScrollTrigger.refresh();
        }, 100);

        return () => {
            context.clear();
        }
    }, {})

    const logosStyle = {
        display: "flex",
        // width: "111.451px",
        height: "16.202px",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "8.838px",
    }

    const closemobile = {
        position: "static",
        width: "17px",
        fontSize: "17px",
        color: 'white',
        height: "calc(var(--vw) * 33px)",
        borderRadius: "50%",
        zIndex: 30000,
        transform: "none"
    };

    const mobileHeaderStyle = {
        background: "var(--purple, #CA89FE)",
        boxShadow: "0px 0.491px 0px 0px #DDD",
        display: "flex",
        padding: "7.856px",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
        position: "fixed",
        top: "0",
        left: "0",
        maxWidth: "100%",
        width: "calc(100% - 16px)",
        zIndex: 1000001,
    };

    const deviceType = useDeviceDetection();

    return (
        <>
            <motion.div
                id="modal"
                className="gefen-programs-backdrop"
                onClick={() => n('/gefen', { state: { dontReload: true } })}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6 }}
            >

                <ReactLenis
                    ref={lenisRef}
                    root={false} options={{
                        // autoRaf: false
                        duration: 1.9,
                        touchMultiplier: 0.4,
                        easing: (x) => 1 - Math.pow(1 - x, 3)
                    }}
                >
                    {deviceType?.isMobile &&
                        <div className="mobile-modal-header" style={mobileHeaderStyle}>
                            <div className="flex" style={logosStyle}>
                                {lnet}{gada}
                            </div>
                            <ProgarmModalButton style={closemobile} n={n}
                            />
                        </div>}
                    <Outlet />
                    <SlidingDashNav n={n} />
                </ReactLenis>
                <div onClick={(e) => e.stopPropagation()}>
                    <ScrollArrow diffrentLenis={lenisRef?.current?.lenis} />
                </div>
            </motion.div>

        </>
    )
}



const navigationButtonStyle = {
    display: "flex",
    width: "calc(var(--vw) * 61.658px)",
    height: "calc(var(--vw) * 61.658px)",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "calc(var(--vw) * 18.88px)",
    flexShrink: 0,
    borderRadius: "50%",
    background: "var(--orange)"
};


const closeStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "calc(var(--vw) * 54px)",
    fontSize: "16px",
    height: "calc(var(--vw) * 54px)",
    borderRadius: "50%",
    zIndex: 30000,
    transform: "none",
    background: "var(--orange) !important"
};

const navStyle = {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    maxWidth: "calc(var(--vw)* 1380px)",
    alignSelf: 'center',
    position: 'fixed',
    top: '30px',
    zIndex: '1'
};

export function SlidingDashNav({ n }) {

    // useGSAP(() => {
    //     gsap.to('.gefen-programs-backdrop .nav', {
    //         top: '15px', //ease:'power2.inOut',
    //         scrollTrigger: {
    //             scroller: '.gefen-programs-backdrop  > div',
    //             endTrigger: '.gefen-programs-backdrop .section-2', end: 'end 30%',
    //             trigger: '.gefen-programs-backdrop .nav', start: 'top 200px', scrub: 0.5,
    //             markers: true
    //         }
    //     })

    //     setTimeout(() => {
    //         ScrollTrigger.refresh();
    //     }, 100);
    // }, [])

    return (
        <>
            <div className="nav" style={navStyle}
                onClick={(e) => e.stopPropagation()} >
                <ProgarmModalButton style={closeStyle} n={n}
                />
            </div>
        </>
    );
}


